export class ImageCarousel {
  slideIndex: number;
  images: any[] = []
}